"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isAOZone", {
    enumerable: true,
    get: function() {
        return isAOZone;
    }
});
const _constants = require("../constants");
const isAOZone = (floodzone)=>{
    return floodzone === _constants.FLOOD_ZONES.AO;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NlcnZpY2VzL2Zpcm1IZWxwZXJzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEZMT09EX1pPTkVTIH0gZnJvbSBcIi4uL2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgaXNBT1pvbmUgPSAoZmxvb2R6b25lPzogTWF5YmU8c3RyaW5nPikgPT4ge1xuICByZXR1cm4gZmxvb2R6b25lID09PSBGTE9PRF9aT05FUy5BTztcbn07XG4iXSwibmFtZXMiOlsiaXNBT1pvbmUiLCJmbG9vZHpvbmUiLCJGTE9PRF9aT05FUyIsIkFPIl0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7MkJBRmU7QUFFckIsTUFBTUEsV0FBVyxDQUFDQztJQUN2QixPQUFPQSxjQUFjQyxzQkFBVyxDQUFDQyxFQUFFO0FBQ3JDIn0=